import { useParams } from 'react-router';
import { useTelemetryContext } from '../contexts/TelemetryContext';
import { getProSlug } from '../utils/pluginPlan';

export function useProductSlugs() {
	const { productId } = useParams();
	const { selectedProduct } = useTelemetryContext();
	const freeSlug = selectedProduct?.slug || '';
	const proSlug = getProSlug(freeSlug);

	return {
		freeSlug,
		proSlug,
		productId: productId || selectedProduct?.id,
	};
}
